/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   getMessageWithIntent
 */

import { APPLY, type MESSAGE, TOUR, type WAITLIST } from '@zcode/nr/es/shared/constants/message'
import type { FloorplanListing } from '@zcode/state-type'

interface Props {
  bedsBathsText?: FloorplanListing['bedsBathsText']
  intent: typeof APPLY | typeof MESSAGE | typeof TOUR | typeof WAITLIST | undefined
  moveIn: string | null
  msg: string
}

export const getMessageWithIntent = ({ bedsBathsText, intent, moveIn, msg }: Props) => {
  if (intent === APPLY) {
    const moveInText = moveIn ? ` for ${moveIn}` : ''
    const floorplanText = bedsBathsText ? ` for ${bedsBathsText}\n\n` : '\n\n'
    return `New! Application request${moveInText}${floorplanText}${msg}`
  }
  if (intent === TOUR) {
    return msg
  }
  const moveInText = moveIn ? `: Move-in ${moveIn}\n\n` : '\n\n'

  return `Info Request${moveInText}${msg}`
}
